import {useTranslation} from '@/translations/i18n'
import {DialogStore} from '@ariakit/react'
import {Dialog, DialogDismiss, DialogFooter, DialogProvider} from '@components/ui/dialog-atoms/DialogAtoms.tsx'
import {Button} from '@components/ui/button/Button.tsx'
import {Spinner} from '@components/ui/spinner/Spinner'
import {StyledDialogHeader, StyledSubmissionDialogBody} from './style'

interface ProPhotosConfirmSubmitModalProps {
    store: DialogStore
    onSubmit: () => void
    isPending: boolean
}

export const ProPhotosConfirmSubmitModal = ({store, onSubmit, isPending}: ProPhotosConfirmSubmitModalProps) => {
    const {t} = useTranslation()

    return (
        <DialogProvider store={store}>
            <Dialog width={'480px'} hideOnInteractOutside={!isPending}>
                <StyledDialogHeader>
                    <DialogDismiss disabled={isPending} />
                </StyledDialogHeader>
                <StyledSubmissionDialogBody gap={2}>
                    <h3>{t('vetting:reordering:submit_photo_modal:title')}</h3>
                    <p>{t('vetting:reordering:submit_photo_modal:description')}</p>
                </StyledSubmissionDialogBody>
                <DialogFooter>
                    <Button variant={'tertiary'} onClick={() => store.toggle()} disabled={isPending}>
                        {t('commons:cancel')}
                    </Button>

                    <Button variant={'primary'} onClick={onSubmit} disabled={isPending}>
                        {t('vetting:reordering:submit_photo_modal:cta')}
                        {isPending && <Spinner size={20} />}
                    </Button>
                </DialogFooter>
            </Dialog>
        </DialogProvider>
    )
}
